import { useParams } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { FormPreviewContent } from "../components/FormPreviewContent";

export function FormDetailsPage() {
  const { formId } = useParams();
  const { user } = useAuth();
  const { businessId } = useCurrentBusiness();
  return (
    <Page>
      <PageHeader title="Form preview" />
      <PageContent>
        {formId ? <FormPreviewContent key={`${user?.id}:${businessId}:${formId}`} formId={formId} /> :
          <EmptyState title="Form unavailable" message="Select a form from the Forms list." />}
      </PageContent>
    </Page>
  );
}
